'use client';
import { createContext, useContext } from 'react';
export const FieldContext = createContext(null);
export function useFieldContext() {
    return useContext(FieldContext);
}
//# sourceMappingURL=FieldContext.js.map